import { ScrollablePane, ScrollbarVisibility, Stack } from '@fluentui/react';
import { PanelType } from 'office-ui-fabric-react';
import { ConstrainMode, DetailsList, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Label } from 'office-ui-fabric-react/lib/Label';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataDenonciation } from '../../data/DataDenonciation.jsx';
import { IDS_TYPE_MANDAT } from '../../data/DataTypeMandat.jsx';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxCompte } from '../ComboBox/ComboBoxCompte';
import { ComboBoxSociete } from '../ComboBox/ComboBoxSociete';
import { EUIPanel } from '../EUI/EUIPanel.jsx';
import { EUISeparator } from '../EUI/EUISeparator.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class FicheDenonciation extends Component {

    static defaultProps = {
        estAffectation: false,
        isOpen: false,
        onDismiss: () => null,
        onSave: () => null,
    };

    static defaultState = {
        denonciation: {},
        itemsOperation: [],
        monCompte: null,
        peutDenoncerDesContacts: false,
        peutDenoncerPourQQ1Autre: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheDenonciation.defaultState };
        this._columns = this._getColumns();
        this._selection = new Selection({ onSelectionChanged: this._onSelectionChanged });
    };

    _chargementDroits = () => {
        DataDenonciation._chargementDroitsDenonciation().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;

                const peutDenoncerDesContacts = objetData[0];
                const peutDenoncerPourQQ1Autre = objetData[1];
                const monCompte = objetData[2];

                let state = { monCompte, peutDenoncerDesContacts, peutDenoncerPourQQ1Autre };
                let callback = undefined;

                if (!peutDenoncerPourQQ1Autre) { // On pré-positionne les données
                    state.denonciation = {
                        idSociete: monCompte.compteTrav.idSociete,
                        loginCompte: monCompte.compteTrav.loginCompte,
                        idOperation: 0
                    };
                    callback = () => this._chargementOperations(monCompte.compteTrav.loginCompte); // On charge le tableau des opérations
                }

                this.setState(state, callback);
            }
            else {
                const state = {
                    monCompte: null,
                    peutDenoncerDesContacts: false,
                    peutDenoncerPourQQ1Autre: false,
                };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });
    };

    _chargementOperations = (loginCompte) => {

        const { estAffectation, listeIdContacts } = this.props;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des opérations en cours'
        });

        const method = estAffectation
            ? () => DataDenonciation._chargementOperationsDenonciationPourAjout(loginCompte)
            : () => DataDenonciation._chargementOperationsDenonciationPourSuppression(loginCompte, listeIdContacts)
            ;

        method().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const itemsOperation = responseFetch.reponseAPIobjet;
                const state = { itemsOperation };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                const state = { itemsOperation: [] };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });

    };

    _getColumns = () => {
        return [{
            className: "ms-hiddenMdDown",
            fieldName: "nomCommercial",
            headerClassName: "ms-hiddenMdDown",
            isResizable: true,
            key: "nomCommercial",
            name: "Nom commercial",
            onRender: (item) => {
                const nomCommercial = item.nomCommercial;
                return <span title={nomCommercial}>{nomCommercial}</span>;
            }
        },
        {
            key: "region",
            name: "Région",
            fieldName: "region",
            minWidth: 100,
            maxWidth: 500,
            isResizable: true,
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            onRender: (item) => {
                const region = item.region;
                return <span title={region}>{region}</span>;
            }
        },
        {
            className: "ms-hiddenMdDown",
            fieldName: "agence",
            headerClassName: "ms-hiddenMdDown",
            isResizable: true,
            key: "agence",
            minWidth: 100,
            maxWidth: 500,
            name: "Agence",
            onRender: (item) => {
                const agence = item.agence;
                return <span title={agence}>{agence}</span>;
            }
        }];
    };

    _onDismiss = () => {
        const { onDismiss } = this.props;
        this.setState({ ...FicheDenonciation.defaultState }, onDismiss);
    };

    _onOpen = () => {
        this._chargementDroits();
    };

    _onSave = () => {

        const { estAffectation, listeIdContacts, onSave } = this.props;
        const { denonciation } = this.state;

        if (this._validationFormulaire(denonciation)) {

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Enregistrement en cours'
            });

            const method = estAffectation
                ? () => DataDenonciation._onEnregistrementDenonciation(listeIdContacts, denonciation)
                : () => DataDenonciation._onSuppressionDenonciation(listeIdContacts, denonciation)
                ;

            method().then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...FicheDenonciation.defaultState });
                    onSave();
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
        }
    };

    _onSelectionChanged = () => {
        const listeIdOperations = this._selection.getSelection().map((operation) => operation.idOperation);
        Scriba.state().setObjetPropriete(this, "denonciation", "listeIdOperations", listeIdOperations);
    };

    _renderComboBoxSociete = () => {
        const { estAffectation, listeIdContacts } = this.props;
        const { denonciation, monCompte, peutDenoncerPourQQ1Autre } = this.state;

        const onChange = (idSociete) => {
            const denonciation = { ...this.state.denonciation, idSociete, loginCompte: "" };
            this.setState({ denonciation, itemsOperation: [] });
        };

        if (!!monCompte && !peutDenoncerPourQQ1Autre)
            return <div>
                <Label>Société</Label>
                <div>{monCompte.saSociete.nom}</div>
            </div>;

        else return <ComboBoxSociete
            id="cbSociete"
            listeIdContacts={!estAffectation ? listeIdContacts : undefined}
            onChange={(event, option, index, value, item) => onChange(item.idSociete)}
            required
            selectedKey={denonciation.idSociete}
        />;
    };

    _renderComboBoxCompte = () => {
        const { estAffectation, listeIdContacts } = this.props;
        const { denonciation, monCompte, peutDenoncerPourQQ1Autre } = this.state;

        const onChange = (loginCompte) => {
            Scriba.state().setObjetPropriete(this, "denonciation", "loginCompte", loginCompte);
            this._chargementOperations(loginCompte);
        };

        if (!!monCompte && !peutDenoncerPourQQ1Autre)
            return <div>
                <Label>Commercialisateur</Label>
                <div>{monCompte.compteTrav.loginCompte}</div>
            </div>;

        else return <ComboBoxCompte
            avecValeurDefaut={false}
            disabled={!denonciation.idSociete}
            id="cbCompte"
            idSociete={denonciation.idSociete}
            idsTypesMandats={[IDS_TYPE_MANDAT.COMMERCIALISATEUR]}
            label="Commercialisateur"
            listeIdContacts={!estAffectation ? listeIdContacts : undefined} // AF 12/12 - Liste des contacts - Supprimer des dénonciations, on préfiltre les combo en fonction des commercialisateurs dénoncés sur les contacts selectionnés
            onChange={(event, option) => onChange(option.key)}
            required
            selectedKey={denonciation.loginCompte}
        />;
    };

    _validationFormulaire = (item) => {
        let estValide = true;

        estValide = estValide && (this.props.listeIdContacts !== undefined && this.props.listeIdContacts.length > 0 ? true : false);

        if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
            estValide = estValide && Scriba.formulaire().nEstPasVide(item.loginCompte);
            estValide = estValide && (item.listeIdOperations !== undefined && item.listeIdOperations.length > 0 ? true : false);
        }
        else estValide = false;

        return estValide;
    };

    render = () => {

        const { estAffectation, isOpen } = this.props;
        const { denonciation, peutDenoncerDesContacts } = this.state;

        const isFormValid = this._validationFormulaire(denonciation) && peutDenoncerDesContacts;

        return <EUIPanel
            headerText={estAffectation ? "Poser des dénonciations" : "Supprimer des dénonciations"}
            isFormValid={isFormValid}
            isOpen={isOpen}
            onDismiss={this._onDismiss}
            onOpen={this._onOpen}
            onSave={this._onSave}
            styles={{ content: { height: "calc(100% - 92px)" } }} // 63px (ComboBoxes) + 22px (Separator)
            type={PanelType.medium}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack horizontal tokens={{ childrenGap: "8px" }}>
                <Stack.Item grow>{this._renderComboBoxSociete()}</Stack.Item>
                <Stack.Item grow>{this._renderComboBoxCompte()}</Stack.Item>
            </Stack>

            <EUISeparator />

            <div className="position-relative h-100">
                <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                    <Label>Liste des opérations</Label>
                    <DetailsList
                        items={this.state.itemsOperation}
                        listProps={{ id: "dlOperation" }}
                        columns={this._columns}
                        selectionMode={SelectionMode.multiple}
                        selection={this._selection}
                        constrainMode={ConstrainMode.unconstrained}
                    />
                </ScrollablePane>
            </div>
        </EUIPanel>;

    };

};